export const environment = {
  production: false,
  serverUrl: 'https://api-dev.alt-pay.in',
  // serverUrl: 'http://localhost:4100',
};